const UPLOADS = 'https://excellentcareclinics.nl/wp-content/uploads';

export const clinic = {
  name: 'Excellent Care Clinics',
  tagline: 'Uw pijn, is onze zorg',
  phone: '085-0479273',
  phoneHref: 'tel:+31850479273',
  email: 'velsen@excellentcareclinics.nl',
  street: 'Leeghwaterweg 1b',
  postalCode: '1951 NA',
  city: 'Velsen-Noord',
  hours: 'Ma t/m vr · 08:30 – 12:00 en 13:00 – 16:30',
  phoneHours: 'Werkdagen 09:00 – 16:00',
  painInfoUrl: 'https://pijnkompas.nl/',
  zorgkaartUrl: 'https://www.zorgkaartnederland.nl/zoeken?q=Excellent%20Care%20Clinics',
  termsPdf: `${UPLOADS}/2025/10/Algemene-voorwaarden.pdf`,
  socials: [
    { label: 'Facebook', href: 'https://www.facebook.com/excellentcareclinics/' },
    { label: 'Instagram', href: 'https://instagram.com/excellentcareclinics/' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/excellent-care-clinics/about/' },
  ],
};

export const finance = {
  iban: 'NL17 ABNA 0832 3223 34',
  bic: 'ABNANL2A',
  accountHolder: 'Stichting Excellent Care Clinics',
  financePhone: '085 – 0220 245',
  financePhoneHref: 'tel:+31850220245',
  financeEmail: 'finance@excellentcareclinics.nl',
  claimsEmail: 'declaraties@excellentcareclinics.nl',
  claimsHours: 'Maandag t/m donderdag, 09:00 – 12:00',
  complaintsEmail: 'klachtenfunctionaris@excellentcareclinics.nl',
};

export interface NavLinkItem {
  label: string;
  to: string;
  external?: boolean;
  description?: string;
}

export interface NavGroup {
  label: string;
  to?: string;
  external?: boolean;
  intro?: string;
  children?: NavLinkItem[];
}

export const patientLinks: NavLinkItem[] = [
  { label: 'Patiënteninformatie', to: '/patienten-informatie', description: 'Nazorginformatie en patiëntenfolders' },
  { label: 'Tarieven', to: '/tarieven', description: 'Passantenprijslijst, eigen risico en declareren' },
  { label: 'Herhaalmedicatie', to: '/herhaalmedicatie', description: 'Vraag tijdig een herhaalrecept aan' },
  { label: 'Klachteninformatie', to: '/klachteninformatie', description: 'Niet tevreden? Laat het ons weten' },
  { label: 'Uitleg over pijn', to: 'https://pijnkompas.nl/', external: true, description: 'Meer weten over hoe pijn werkt' },
];

export const aboutLinks: NavLinkItem[] = [
  { label: 'Over de kliniek', to: '/over-ons', description: 'Visie op kwaliteit en veiligheid' },
  { label: 'Ons team', to: '/team', description: 'Pijnspecialisten, verpleegkundigen en staf' },
  { label: 'Ervaringen', to: '/ervaringen', description: 'Wat patiënten over ons zeggen' },
  { label: 'Vacatures', to: '/vacatures', description: 'Werken bij Excellent Care Clinics' },
];

export const mainNav: NavGroup[] = [
  { label: 'Pijnklachten', to: '/pijnbehandelingen' },
  { label: 'Behandelingen', to: '/behandelingen' },
  {
    label: 'Patiënten',
    intro: 'Praktische informatie voor, tijdens en na uw behandeling.',
    children: patientLinks,
  },
  {
    label: 'Over ons',
    intro: 'Onafhankelijk specialistisch pijnbehandelcentrum in Velsen-Noord.',
    children: aboutLinks,
  },
  { label: 'Verwijzers', to: '/verwijzers' },
];

export const images = {
  reception: `${UPLOADS}/2023/05/DSC7802-scaled-1.jpg`,
  consult: 'https://cdn.magicpatterns.com/patterns/generated-images/e6295aaa-41d8-463f-93f3-f361d34d4ff4.jpg',
  procedure: `${UPLOADS}/2023/05/DSC7957-scaled-1.jpg`,
};

/** The three promises from the current homepage. */
export const highlights = [
  { title: 'Korte wachttijden', text: 'Wij hebben korte wachttijden.' },
  { title: 'Vergoede zorg', text: 'Al onze behandelingen worden vergoed vanuit de basisverzekering.' },
  { title: 'Intake', text: 'Bij het eerste consult, de mogelijkheid tot behandeling.' },
];

/** Based on the referral process described on the Verwijzers page. */
export const careSteps = [
  { title: 'Verwijzing', text: 'Uw huisarts of specialist stuurt een verwijzing via Zorgdomein of per e-mail, of geeft deze aan u mee.' },
  { title: 'Wij nemen contact op', text: 'Zodra de verwijzing binnen is, nemen wij contact met u op. U kunt binnen één tot vier weken terecht voor een intake.' },
  { title: 'Intake & behandeling', text: 'Na het intakegesprek kunnen wij snel starten met de behandeling van uw klachten.' },
  { title: 'Terugkoppeling', text: 'Uw verwijzer wordt op de hoogte gehouden van het behandelplan en het verloop.' },
];

export const roles = [
  {
    title: 'Verpleegkundig specialist in opleiding',
    text: 'Een gespecialiseerd verpleegkundige met bepaalde artsenbevoegdheden, in opleiding op universitair masterniveau. Voert consulten uit, bespreekt diagnoses en behandelopties en kan binnen het eigen deskundigheidsgebied behandelingen inzetten en medicatie voorschrijven — altijd onder supervisie van de pijnspecialist.',
  },
  {
    title: 'Verpleegkundige in opleiding tot pijnconsulent',
    text: 'Een pijnconsulent is een gespecialiseerd verpleegkundige in de pijnbestrijding. Geeft uitleg over pijn, ondersteunt bij het behandelplan dat de pijnspecialist heeft ingezet en is aanspreekpunt voor vragen over de behandeling.',
  },
];
